import { render, staticRenderFns } from "./ReferralDetailReport.vue?vue&type=template&id=eb212444&"
import script from "./ReferralDetailReport.vue?vue&type=script&lang=js&"
export * from "./ReferralDetailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports